import widgetDefinition from './widgetdefinition'

HTMLWidgets.widget(widgetDefinition)
